import { IParsedVersionMapping } from '../tree/TreeActions'
import { Box, Button } from '@mui/material'
import * as React from 'react'
import { goToNode } from '../masters_management/utility'
import { NodeIdMap } from './utility'

export function MappingDuplicates({
  mapping,
  sourceIdMapping,
  destinationMapping,
}: {
  mapping: IParsedVersionMapping
  sourceIdMapping: NodeIdMap
  destinationMapping: NodeIdMap
}) {
  return (
    <Box>
      {!!mapping.noFromNode.length && (
        <Box>{mapping.noFromNode.length} Mappings Without From Node</Box>
      )}
      <Box>{Object.keys(mapping.duplicates).length} Duplicates</Box>
      <Box>
        {Object.keys(mapping.duplicates).map((dupKey) => {
          const dups = mapping.duplicates[dupKey]
          const { node: destNode, treePath: destPath } =
            destinationMapping[dupKey]
          return (
            <Box key={dupKey} padding={'5px'} border={'1px solid'}>
              <Box>
                In the new version:{' '}
                <Button onClick={() => goToNode(destNode)}>
                  {destNode?.title}
                </Button>
              </Box>
              <Box>
                <b>{destPath}</b>
              </Box>
              <Box padding={'5px'}>
                <Box>
                  Is being mapped to by these nodes in the previous version:
                </Box>
                <Box padding={'5px'}>
                  {dups.map((dup) => {
                    const { node: sourceNode, treePath: sourcePath } =
                      sourceIdMapping[dup.from_node_id]
                    return (
                      <Box
                        borderTop={'solid 1px'}
                        key={sourceNode.id}
                        paddingTop={'5px'}
                        paddingBottom={'5px'}
                      >
                        <Box>
                          <Button onClick={() => goToNode(sourceNode)}>
                            {sourceNode.title}
                          </Button>
                          mapping ID: {dup.id}
                        </Box>
                        <Box>{sourcePath}</Box>
                      </Box>
                    )
                  })}
                </Box>
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
